import LoadableActivityList from './loadable_activity_list'
import ReactComponent from 'lib/modulor/react_component'

ReactComponent.register(LoadableActivityList, 'Modulor.ActivityList')
